import React, { useState } from 'react';
import styles from './LoginForm.module.css';
import AuthHeader from '../ui/AuthHeader/AuthHeader';
import FieldsAuth from '../ui/FieldsAuth/FieldsAuth';
import ButtonLogin from './ButtonLogin';
import { NavLink, useNavigate } from 'react-router-dom';
import { login } from '../../api/Authentication';

const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [visibility, setVisibility] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    async function handleForm(e) {
        e.preventDefault();
        setError('');

        const result = await login(email?.trim().toLowerCase(), password?.trim());

        if (result.success) {
            const role = result.data.role;
            const id = result.data.id;
            localStorage.setItem('user', JSON.stringify({ id, role }));
            if (role === 'trader') navigate('/trader');
            else if (role === 'client') navigate('/');
            else if (role === 'admin') navigate('/admin');
        } else {
            localStorage.removeItem('user');
            setError(result.error.message);
        }
    }
    
    return (
        <form onSubmit={handleForm} className={styles.form}>
            <AuthHeader action='Connexion' />
            <FieldsAuth index='email' value={email} setValue={setEmail} />
            <FieldsAuth index='passwordLogin' value={password} setValue={setPassword} visibility={visibility} setVisibility={setVisibility} />
            <ButtonLogin />
            <p className={styles.error}>{error}</p>
            <p className={styles.paragraph}>
                Nouveau sur DealyGo?
                <NavLink className={styles.span} to='/register'>
                    Créer un compte
                </NavLink>
            </p>
        </form>
    );
};

export default LoginForm;